export default __webpack_public_path__ + "static/media/walking-icon.ce2eba21.webp";